import React, { FC, memo, ReactNode } from 'react';

import { Icon } from '../RoundedIcon';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import styled from '@emotion/styled';
import { COLORS } from '../../styles';
import { SectionHeader } from '../../Scenes/Settings/styles';
import { Box } from '~Styles';
import SettingsBlockItem from './SettingsBlockItem';

const SettingsBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: var(--colorBlueGray1100);
  overflow: hidden;
`;

export type SettingBlockItemType = {
  id: string;
  title: string;
  bigTitle?: boolean;
  description?: string | ReactNode; // You can use the ReactNode with <BlurryBox /> to show a loading skeleton
  prefixIcon?: Omit<Icon, 'margin' | 'color'>;
  prefixColor?: string;
  disabled?: boolean;
  disabledToast?: string;
  additionalText?: {
    left?: string | ReactNode;
    right?: string;
  };
  action?: {
    title?: string;
    icon?: Omit<Icon, 'margin' | 'bgColor' | 'color'>;
    isToggle?: boolean;
    selected?: boolean;
    selectedColor?: keyof typeof COLORS;
    onClick: () => void;
  };
  isRemotelyControlled?: boolean;
};

type Props = {
  title?: string;
  items: SettingBlockItemType[];
};

const HandySettingsBlock: FC<Props> = ({ title, items }) => {
  return (
    <Box marginTop="small">
      {title && (
        <SectionHeader>
          <Paragraph upperCase={true} level={5} color="var(--colorBlueGray200)">
            {title}
          </Paragraph>
        </SectionHeader>
      )}
      <SettingsBlock>
        {items.map((item) => (
          <SettingsBlockItem key={item.id} item={item} />
        ))}
      </SettingsBlock>
    </Box>
  );
};

export default memo(HandySettingsBlock);
